import { render, staticRenderFns } from "./brand.vue?vue&type=template&id=2fdcb7ed&scoped=true&"
import script from "./brand.vue?vue&type=script&lang=js&"
export * from "./brand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdcb7ed",
  null
  
)

export default component.exports